"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NxsSingleFileModelAdapter = void 0;
const axios_1 = __importDefault(require("axios"));
const readers_1 = require("../readers");
/**
 * Makes ranged requests to retrieve parts of nexus model file.
 */
class NxsSingleFileModelAdapter {
    constructor(modelUrl, tokenProvider) {
        this.modelUrl = modelUrl;
        this.tokenProvider = tokenProvider;
    }
    fetchHeader() {
        return this.makeRangedRequest(NxsSingleFileModelAdapter.HEADER_BYTE_START, NxsSingleFileModelAdapter.HEADER_BYTE_SIZE)
            .then(buffer => new readers_1.HeaderParser(buffer).parse());
    }
    fetchIndex(header) {
        const end = NxsSingleFileModelAdapter.HEADER_BYTE_SIZE
            + header.nodesCount * NxsSingleFileModelAdapter.INDEX_NODE_BYTE_SIZE
            + header.patchesCount * NxsSingleFileModelAdapter.INDEX_PATCH_BYTE_SIZE
            + header.texturesCount * NxsSingleFileModelAdapter.INDEX_TEXTURE_BYTE_SIZE;
        return this.makeRangedRequest(NxsSingleFileModelAdapter.HEADER_BYTE_SIZE, end)
            .then(buffer => new readers_1.NodesParser(buffer).parse(header));
    }
    fetchNode(range) {
        return this.makeRangedRequest(range.start, range.end);
    }
    fetchNodeTexture(range) {
        return this.makeRangedRequest(range.start, range.end, 'blob');
    }
    makeRangedRequest(byteStart, byteEnd, type = 'arraybuffer') {
        const token = this.tokenProvider ? this.tokenProvider() : undefined;
        const rangeHeader = { range: `bytes=${byteStart}-${byteEnd - 1}` };
        const auth = token ? { Authorization: `Bearer ${token}` } : null;
        const headers = Object.assign(Object.assign({}, rangeHeader), auth);
        const requestConfig = {
            responseType: type,
            headers: headers
        };
        return axios_1.default.get(this.modelUrl, requestConfig)
            .then(response => {
            switch (response.status) {
                case NxsSingleFileModelAdapter.SUCCESSFUL_RANGE_REQUEST:
                    return response.data;
                case NxsSingleFileModelAdapter.SUCCESSFUL_NON_RANGE_REQUEST:
                    throw "200 response; server does not support byte range requests.";
                default:
                    throw "Unsupported response status " + response.status;
            }
        }).catch(reason => {
            reason.aborted = axios_1.default.isCancel(reason);
            return reason;
        });
    }
}
exports.NxsSingleFileModelAdapter = NxsSingleFileModelAdapter;
NxsSingleFileModelAdapter.HEADER_BYTE_START = 0;
NxsSingleFileModelAdapter.HEADER_BYTE_SIZE = 88;
NxsSingleFileModelAdapter.SUCCESSFUL_RANGE_REQUEST = 206;
NxsSingleFileModelAdapter.SUCCESSFUL_NON_RANGE_REQUEST = 200;
NxsSingleFileModelAdapter.INDEX_NODE_BYTE_SIZE = 44;
NxsSingleFileModelAdapter.INDEX_PATCH_BYTE_SIZE = 12;
NxsSingleFileModelAdapter.INDEX_TEXTURE_BYTE_SIZE = 68;
